module.exports = __webpack_public_path__ + "static/media/facebook-podcast.3d438811.svg";